import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  align-items: center;
`;
export const IconContainer = styled.div `
  margin-right: 12px;
`;
export const ContentContainer = styled.div `
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`;
export const TooltipContainer = styled.div `
  margin-left: 6px;
  cursor: pointer;
`;
